<ion-header>
  <div class="flex-space-between" style="padding: 8px">
    <div class="button-container flexed-align-center">
      <div class="flexed-align-center">
        <ion-searchbar
          mode="ios"
          placeholder="Search customers..."
          showCancelButton="never"
          class="rounded-search-bar"
          [(ngModel)]="searchText"
          (ionChange)="handleFilters()"
        ></ion-searchbar>
        <app-filter-button
          [options]="filterOptions"
          (didChange)="filtersDidChange($event)"
          [projectId]="authService.selectedProject?.id ?? undefined"
        ></app-filter-button>
        <ion-button
          color="dark"
          fill="clear"
          class="hidden-sm btn-small"
          (click)="
            showArchived = !showArchived; searchText = ''; loadCustomers()
          "
        >
          <ion-icon
            [name]="showArchived ? 'checkmark-circle' : 'ellipse-outline'"
            class="padded-icon checkbox-icon"
          >
          </ion-icon>
          Show archived
        </ion-button>
      </div>
    </div>
    <div style="display: flex">
      <ion-button
        [hidden]="selectedCustomers.length"
        routerDirection="root"
        [routerLink]="'/dashboard/customers/new'"
        *ngIf="showCreateButton"
      >
        <ion-icon name="logo-slack"></ion-icon>
        <span class="text-with-left-icon hidden-sm"> Connect channels </span>
      </ion-button>
      <ion-button
        [hidden]="selectedCustomers.length"
        (click)="addIndividualCustomer()"
        color="light"
        *ngIf="showCreateButton"
      >
        <ion-icon name="add-outline"></ion-icon>
        <span class="text-with-left-icon hidden-sm"> Add individually </span>
      </ion-button>
      <ion-button
        fill="clear"
        color="dark"
        (click)="exportAsCsv()"
        ngxTippy
        [tippyProps]="{
          arrow: false,
          placement: 'bottom'
        }"
        data-tippy-content="Download as CSV"
        class="hidden-sm"
      >
        <ion-icon name="cloud-download"></ion-icon>
      </ion-button>
    </div>
  </div>
  <div [hidden]="!selectedCustomers.length" style="padding: 8px">
    <ion-button fill="clear" color="dark" [disabled]="true" class="btn-small">
      {{
        selectAllPagesForBulkUpdate
          ? customerListDataSource.lastResponse.totalCount
          : selectedCustomers.length
      }}
      selected:
    </ion-button>
    <ion-button
      (click)="composeEmail()"
      [disabled]="isLoading"
      style="margin: 0 4px"
      class="btn-small"
    >
      <ion-icon name="mail"></ion-icon>
      <span class="text-with-left-icon hidden-sm"> Compose email </span>
    </ion-button>
    <ion-button
      (click)="composeSlack()"
      [disabled]="isLoading"
      style="margin: 0 4px"
      class="btn-small"
    >
      <ion-icon name="logo-slack"></ion-icon>
      <span class="text-with-left-icon hidden-sm">
        Compose Slack broadcast
      </span>
    </ion-button>
    <ion-button
      (click)="manageTags()"
      [disabled]="isLoading"
      color="light"
      style="margin: 0 4px"
      class="btn-small"
    >
      <ion-icon name="pricetags"></ion-icon>
      <span class="text-with-left-icon hidden-sm"> Manage tags </span>
    </ion-button>
    <!-- <ion-button fill="outline" (click)="showEditOptions()" [disabled]="isLoading" style="margin: 0 4px">
      <span class="text-with-right-icon hidden-sm"> Edit </span>
      <ion-icon name="chevron-down-outline" class="button-icon"></ion-icon>
    </ion-button> -->
    <ng-container *ngIf="selectedCustomers.length >= limit">
      <ng-container *ngIf="!selectAllPagesForBulkUpdate">
        <ion-button
          fill="clear"
          color="dark"
          (click)="selectAllPagesForBulkUpdate = true"
          class="btn-small"
        >
          Select all
          {{ customerListDataSource.lastResponse.totalCount }} customers?
        </ion-button>
      </ng-container>
    </ng-container>
    <ion-button
      fill="clear"
      color="dark"
      (click)="selectedCustomers = []; selectAllPagesForBulkUpdate = false"
      [disabled]="isLoading"
      style="margin: 0 4px"
      class="btn-small"
    >
      Clear selection
    </ion-button>
  </div>
</ion-header>
<ion-content>
  <ng-container>
    <ngx-datatable
      class="material datatable-row-borders"
      [columnMode]="ColumnMode.force"
      [limit]="limit"
      [headerHeight]="44"
      [footerHeight]="50"
      [rowHeight]="50"
      [scrollbarH]="true"
      [selected]="selectedCustomers"
      selectionType="checkbox"
      [selectAllRowsOnPage]="false"
      [displayCheck]="false"
      style="height: unset"
      paginated
      [dataSource]="customerListDataSource"
      [reorderable]="true"
      (select)="onSelect($event)"
      [loadingIndicator]="isLoading"
    >
      <ngx-datatable-column
        [width]="44"
        [minWidth]="44"
        [sortable]="false"
        [canAutoResize]="false"
        [draggable]="false"
        [resizeable]="false"
        [headerCheckboxable]="true"
        [checkboxable]="true"
      >
      </ngx-datatable-column>
      <ngx-datatable-column name="Name" [minWidth]="250">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <a
            [routerLink]="['/dashboard/customers', row.id, 'members']"
            routerDirection="root"
            class="vertical-align-center"
            style="font-weight: 600"
          >
            <div style="width: 29px; height: 29px; margin-right: 10px">
              <img
                *ngIf="row.slackTeams?.length === 1 && row.slackTeams[0]?.icon"
                [src]="row.slackTeams[0].icon"
                style="object-fit: cover; border-radius: 8px"
              />
              <div
                *ngIf="
                  row.slackTeams?.length !== 1 ||
                  (row.slackTeams?.length === 1 && !row.slackTeams[0]?.icon)
                "
                style="
                  width: 100%;
                  border-radius: 8px;
                  background: rgba(var(--ion-color-primary-rgb), 0.05);
                  color: rgba(var(--ion-color-primary-rbg), 0.7);
                  height: 100%;
                  padding: 7px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 0.95rem;
                "
              >
                <ion-icon name="business"></ion-icon>
              </div>
            </div>
            <span class="row-title">
              {{ row.name ?? PRIVATE_CHANNEL_NAME }}
            </span>
          </a>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="Channel"
        prop="slackChannel?.name"
        [minWidth]="225"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-icon
            name="lock-closed"
            *ngIf="row.slackChannel?.isPrivate"
          ></ion-icon>
          <span *ngIf="row.slackChannel?.name && !row.slackChannel?.isPrivate"
            >#</span
          >
          <span *ngIf="row.slackChannel">{{
            formatSlackChannelName(row.slackChannel)
          }}</span>
          <i *ngIf="!row.slackChannel">None</i>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Channel members"
        prop="followerCount"
        [maxWidth]="160"
        [minWidth]="160"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge color="light">{{ row.followerCount }}</ion-badge>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="Type"
        prop="isInternal"
        [maxWidth]="120"
        [minWidth]="110"
        [width]="110"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge color="light" *ngIf="row.isInternal"
            ><ion-icon name="people"></ion-icon> internal</ion-badge
          >
          <ion-badge color="light" *ngIf="!row.isInternal">
            <ion-icon name="business"></ion-icon> shared
          </ion-badge>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Tags" [minWidth]="250" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge
            color="success"
            *ngFor="let tag of row.tags"
            (click)="editTagForCustomer(row.id, tag.id)"
            class="clickable"
          >
            <span [title]="getTagsForRow(row)"> {{ tag.name }} </span>
          </ion-badge>
          <ion-button
            class="btn-small"
            fill="clear"
            color="dark"
            style="--padding-start: 4px; --padding-end: 4px; opacity: 0.8"
            (click)="addTagToCustomer(row.id)"
          >
            <ion-label>
              <ion-icon name="pricetag"></ion-icon
              ><ion-icon name="add-outline"></ion-icon>
            </ion-label>
          </ion-button>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="Primary rep"
        prop="primaryRep"
        [minWidth]="200"
        [sortable]="false"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          <ion-button
            class="btn-small"
            fill="clear"
            color="dark"
            (click)="showAssigneeOptions(row, true)"
            [disabled]="isLoadingAssignees && row.primarySupportAssigneeId"
            style="margin-left: -13px"
          >
            <ion-label>
              {{
                isLoadingAssignees && row.primarySupportAssigneeId
                  ? "Loading..."
                  : assigneeLookups[row.primarySupportAssigneeId]
                      ?.displayName ?? "No one"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-button>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="Secondary rep"
        prop="primaryRep"
        [minWidth]="200"
        [sortable]="false"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          <ion-button
            class="btn-small"
            fill="clear"
            color="dark"
            (click)="showAssigneeOptions(row, false)"
            [disabled]="isLoadingAssignees && row.secondarySupportAssigneeId"
            style="margin-left: -13px"
          >
            <ion-label>
              {{
                isLoadingAssignees && row.secondarySupportAssigneeId
                  ? "Loading..."
                  : assigneeLookups[row.secondarySupportAssigneeId]
                      ?.displayName ?? "No one"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-button>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="SLA"
        prop="supportStepRuleset"
        [minWidth]="180"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-button
            class="btn-small"
            fill="clear"
            color="dark"
            (click)="showSLAOptions(row)"
            style="margin-left: -13px"
          >
            <ion-label *ngIf="row.supportStepRuleset?.name">
              {{ row.supportStepRuleset?.name }}
            </ion-label>
            <ion-label
              *ngIf="!row.supportStepRuleset && !row.supportSteps?.length"
            >
              Default
            </ion-label>
            <ion-label *ngIf="row.supportSteps?.length"> Custom </ion-label>
            <ion-label>
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-button>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Project"
        prop="project?.name"
        [minWidth]="225"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-icon
            name="lock-closed"
            *ngIf="row.project?.visibility === PROJECT_VISIBILITY.RESTRICTED"
          ></ion-icon>
          {{ row.project?.name }}
          <i *ngIf="!row.project?.name">None</i>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Domains" [minWidth]="200" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge
            color="warning"
            *ngFor="
              let domain of row.emailDomains ??
                row.emailDomainsWrapper?.emailDomains ??
                []
            "
          >
            {{ domain }}
          </ion-badge>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="CRM"
        prop="externalCrmMetadata"
        [sortable]="false"
        [minWidth]="200"
        *ngIf="connectedCrm"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <ion-button
              class="btn-small"
              color="light"
              (click)="openLink(row.externalCrmMetadata.url)"
              *ngIf="row?.externalCrmMetadata?.id"
            >
              Open in {{ connectedCrm }}
              <ion-icon name="open" class="icon-padded-left"></ion-icon>
            </ion-button>
            <ion-button
              class="btn-small button-dark-border"
              color="dark"
              fill="clear"
              (click)="linkCrm(row)"
              *ngIf="!row?.externalCrmMetadata?.id"
            >
              <ion-icon name="unlink-outline" class="padded-icon"></ion-icon>
              Connect
            </ion-button>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="Created"
        prop="createdAt"
        [minWidth]="170"
        [maxWidth]="170"
        [width]="170"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          {{ value | date: "MMM d yyyy" }}
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
    <div *ngIf="allCustomers && !allCustomers.length && searchText?.length">
      <ion-card class="outline-card">
        <div class="empty-state-container" style="padding: 60px">
          <span class="placeholder-emoji">
            <ion-icon name="business-outline"></ion-icon>
          </span>
          <h1 class="placeholder-title">No results</h1>
        </div>
      </ion-card>
    </div>
  </ng-container>
  <div *ngIf="allCustomers && !allCustomers.length && !searchText?.length">
    <ion-card class="outline-card">
      <div class="empty-state-container" style="padding: 60px">
        <span class="placeholder-emoji">
          <ion-icon name="business-outline"></ion-icon>
        </span>
        <h1 class="placeholder-title">No customers yet</h1>
        <p class="placeholder-subtitle">You should probably create one, eh?</p>
        <a [routerLink]="'/customers/new'">Create a customer</a>
      </div>
    </ion-card>
  </div>
</ion-content>
